import { LuAward, LuFileText, LuFileCheck, LuFileMinus } from "react-icons/lu";
import { FiUsers } from "react-icons/fi";
import { useGetInformationQuery } from "../store/services/homepageServices";
import { useNavigate } from "react-router";

export default function Homepage() {
    const { data } = useGetInformationQuery();
    const navigate = useNavigate();

    const info = data?.data;

    const formatValue = (value) =>
        value === undefined || value === null ? "—" : Number(value).toLocaleString();

    const stats = [
        {
            label: "Total receipts",
            value: info?.total_receipts,
            icon: <LuFileText size={24} />,
        },
        {
            label: "Receipts approved",
            value: info?.total_approved_receipts,
            icon: <LuFileCheck size={24} />,
            onClick: () => navigate("/approved_receipts"),
        },
        {
            label: "Receipts pending",
            value: info?.total_pending_receipts,
            icon: <LuFileMinus size={24} />,
            onClick: () => navigate("/pending_receipts"),
        },
        {
            label: "Receipts approved in the last month",
            value: info?.total_previous_approved_receipts,
            icon: <LuFileCheck size={24} />,
        },
        {
            label: "Winners",
            value: info?.total_winners,
            icon: <LuAward size={24} />,
            onClick: () => navigate("/winners"),
        },
        {
            label: "Users registered",
            value: info?.total_registered_users,
            icon: <FiUsers size={24} />,
            onClick: () => navigate("/users"),
        },
    ];

    return (
        <div className="min-h-full bg-gradient-to-b from-gray-50/60 via-white to-white rounded-xl">
            <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8 flex flex-col gap-6">
                <div>
                    <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 tracking-tight">
                        Dashboard
                    </h1>
                    <p className="mt-1 text-sm text-gray-500">
                        Overview of receipts, winners and registered users.
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 sm:gap-5">
                    {stats.map((stat, index) => {
                        const clickable = typeof stat.onClick === "function";
                        return (
                            <button
                                key={index}
                                type="button"
                                onClick={stat.onClick}
                                disabled={!clickable}
                                className={`group flex items-center gap-4 sm:gap-5 text-left rounded-2xl border border-gray-200 bg-white p-5 sm:p-6 shadow-sm transition-all ${clickable ? "cursor-pointer hover:-translate-y-0.5 hover:border-secondary/40 hover:shadow-md" : "cursor-default"
                                    }`}
                            >
                                <span className="flex h-14 w-14 sm:h-16 sm:w-16 shrink-0 items-center justify-center rounded-2xl bg-secondary/10 text-secondary">
                                    {stat.icon}
                                </span>
                                <div className="min-w-0">
                                    <div className="text-3xl sm:text-4xl font-bold leading-none tabular-nums text-gray-900">
                                        {formatValue(stat.value)}
                                    </div>
                                    <div className="mt-2 text-sm text-gray-500">
                                        {stat.label}
                                    </div>
                                </div>
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
